import { render, staticRenderFns } from "./onclive.vue?vue&type=template&id=42384665&scoped=true&v-once=true"
import script from "./onclive.vue?vue&type=script&lang=js"
export * from "./onclive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42384665",
  null
  
)

export default component.exports